import { render } from "./HeroiconsSolidCurrencyYen.vue?vue&type=template&id=4ecad94c"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCurrencyYen.vue"]])

export default __exports__